import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdwtrveqgt: FaireProductEntity = {
  token: "p_pdwtrveqgt",
  type: "product",
  name: "Fanta Pineapple - KOREA (12 COUNT)",
  brandToken: "b_pdahr8yenn",
  brandName: "Exotic Snacks Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/088574e47487ed288a3a93ea064e6a3ef52f8afd3c44e116fd3a7a836b311989.jpeg",
  galleryImageUrls: [],
  priceDollars: 59.58,
  description:
    "Refreshing pineapple-flavored soda from Korea. This 12-count pack delivers tropical taste in every sip. Perfect for parties, gatherings, or stocking your favorite beverages.\n\nMSRP: $4.99\n",
  tags: [],
  msrpDollars: 119.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:06.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
